import {
  ContentTypeRender,
  Link,
  useLocation,
  Wrapper,
} from "nystem-components";
import app from "nystem";

const StyleTabs = ({ model, path }) => {
  const tabs = model.tabs || [];
  const { pathname, search } = useLocation();
  const saveId = model.saveId || "tab";
  const selected = new URLSearchParams(search).get(saveId);
  const selectedTab = tabs.find(({ id }) => id === selected) || tabs[0];

  if (!selectedTab) return null;

  return (
    <Wrapper>
      <Wrapper
        renderAs="div"
        role="tablist"
        className={
          model.tabListClassName || [
            "flex",
            "border-b",
            "border-gray-600",
            "mb-4",
            "gap-1",
          ]
        }
      >
        {tabs.map((tab, index) => {
          const { id, text } = tab;
          const query = new URLSearchParams(search);
          if (index) query.set(saveId, id);
          else query.delete(saveId);

          return (
            <Link
              key={id}
              to={tab.url ? tab.url : `${pathname}?${query.toString()}`}
              role="tab"
              aria-selected={selectedTab.id === id}
              className={`px-4 py-2 border-b-2 ${selectedTab.id === id ? "border-blue-400 font-semibold" : "border-transparent text-gray-400 hover:text-white"}`}
            >
              {app.t(text)}
            </Link>
          );
        })}
      </Wrapper>
      <ContentTypeRender path={path} items={selectedTab.item || []} />
    </Wrapper>
  );
};

export default StyleTabs;
